import { STORAGE_KEY } from './local-storage'

const localStoragePlugin = store => {
    store.subscribe((mutation, state) => {
        // console.log(state.stateLocalStorage.s);
        const syncedData = {
            auth: state.stateLocalStorage.syncedData.auth,
            user: state.stateLocalStorage.syncedData.user ,
            routes: state.stateLocalStorage.syncedData.routes
        }

        localStorage.setItem(STORAGE_KEY, JSON.stringify(syncedData))

        if (mutation.type === 'CLEAR_ALL_DATA') {
            localStorage.removeItem(STORAGE_KEY)
        }
    })
}

// TODO: setup env
// export default process.env.NODE_ENV !== 'production' ? [localStoragePlugin] : [localStoragePlugin]
export default [localStoragePlugin]


// WEBPACK FOOTER //
// ./src/vuex/plugins.js